import { Pipe, PipeTransform } from '@angular/core';
import { LogRecordStatus } from '@fleet-beat/core';

@Pipe({
  name: 'logRecordIcon',
})
export class LogRecordIconPipe implements PipeTransform {
  transform(value: `${LogRecordStatus}`): string | null {
    if (!value) return null;
    switch (value) {
      case LogRecordStatus.PowerOffConventional:
        return 'engine_off';
      case LogRecordStatus.PowerOffReduced:
        return 'engine_off';
      case LogRecordStatus.PowerOnConventional:
        return 'engine_on';
      case LogRecordStatus.PowerOnReduced:
        return 'engine_on';
      case LogRecordStatus.Certification:
        return 'draw';
      case LogRecordStatus.Login:
        return 'login';
      case LogRecordStatus.Logout:
        return 'logout';
      default:
        return null;
    }
  }
}
